namespace RioERP.Shipping {
    export namespace PermissionKeys {
        export const General = "Shipping:General";

        namespace ShippingManagement {
            export const Delete = "Shipping:ShippingManagement:Delete";
            export const Modify = "Shipping:ShippingManagement:Modify";
            export const View = "Shipping:ShippingManagement:View";
        }
    }
}
